import React, { useState } from 'react'
import RequestService from "../../../services/request.service";


import '../../Reportes/mi_reporte.scss';




import { toast } from 'react-toastify'

import moment from 'moment'

import { Modal, Button } from 'react-bootstrap'

// import { SERVER_ } from  '../../../config';

// import Dialog from '../../../services/Dialogs'
import ModalInformeTramite from '../../Mesa_Atencion/ModalInformeTramite'


import ModalNotasTramite from '../../Mesa_Atencion/ModalNotasTramite'


const ListaTramiteGerente = (props)=>{

	// const dialog = new Dialog()

	const { uuid_gerente, fecha_inicio, fecha_fin, show, handleClose } = props

  const [ reporte, setReporte ] = useState<any>({
        gerente : {},
        // fecha_inicio : '',
        // fecha_fin : '',
        tramites : [{
                      folio: "",
                      idestatus: 0,
                      uuid_tramite: "",
                      fecha_tramite: "",
                      nombres: "",
                      paterno: "",
                      materno: "",
                      curp: "",
                      telefono: "",
                      celular: ""
                    }]
      })

  const cargarNoticia = async () =>{
      try{
        var ED = fecha_fin ? moment(fecha_fin).format('YYYY-MM-DD') : null
        let response = await RequestService.getEndPoint('gerencia/reporte_gerente/'+uuid_gerente+'/'+moment(fecha_inicio).format('YYYY-MM-DD')+'/'+ED)
        setReporte(response.data)
      }
      catch(e){
        toast.error('Error al cargar los comentarios')
      }
  }


  React.useEffect(() => {
    cargarNoticia()
  }, []);


  const [ uuid_tramite_modal, setUUIDTramiteSeleccionado ] = useState<any>('')

  const [ showModalInforme, setShowModalInforme ] = useState<boolean>(false)

  const onHideModalInforme = () =>{
    setShowModalInforme(false)
  }

  const fichaTramite = (uuid_tramite:string) => {
    setUUIDTramiteSeleccionado(uuid_tramite)
    setShowModalInforme(true)
  }




  const [ show_ModalNotasTramite, setModalNotasTramite ] = useState<boolean>(false)
  const mensajesTramite = (tramite:any) => {
    setDataTramiteEdit(tramite)
    setModalNotasTramite(true)
  }
  const handleClose_ModalNotasTramite = () => {
    setModalNotasTramite(false)
  }


  const [ data_tramite, setDataTramiteEdit ] = useState<any>({nombres:"",paterno:"",materno:"",folio:"",curp:"",monto:0,rol:''})


	return (

		<React.Fragment>

		      <Modal show={show} backdrop="static" size={'xl'} onHide={handleClose} >
		        <Modal.Header closeButton>
		          <Modal.Title>

                    {
                      moment(fecha_inicio).format('YYYY-MM-DD') !== moment(fecha_fin).format('YYYY-MM-DD') && ('REPORTE ENTRE '+ moment(fecha_inicio).format('DD [DE] MMMM [DEL] YYYY').toUpperCase() + ' Y EL ' + moment(fecha_fin).format('DD [DE] MMMM [DEL] YYYY').toUpperCase() )
                    }
                    {
                      moment(fecha_inicio).format('YYYY-MM-DD') === moment(fecha_fin).format('YYYY-MM-DD') && ('REPORTE PARA EL '+moment(fecha_inicio).format('DD [DE] MMMM [DEL] YYYY').toUpperCase())
                    }

              </Modal.Title>
		        </Modal.Header>
		        <Modal.Body>

                <dl style={{marginBottom:0}}>
                    <dt><b>Gerente</b></dt>
                    <dd>{reporte.gerente.nombres} {reporte.gerente.paterno} {reporte.gerente.materno}</dd>

                    <dt><b>Celular</b></dt>
                    <dd>{reporte.gerente.celular}</dd>

                    <dt><b>Trámites</b></dt>
                </dl>




                <table className="table" style={{marginTop:0}}>
                  <thead>
                    <tr>
                      <th scope="col"></th>
                      <th scope="col">Folio</th>
                      <th scope="col">Fecha</th>
                      <th scope="col">Estatus</th>
                      <th scope="col">Cliente</th>
                      <th scope="col">Asesor</th>
                      <th scope="col"></th>
                    </tr>
                  </thead>
                  <tbody>
                        {
                          reporte.tramites.map( (tramite:any,index:number) =>

                          <tr key={ Math.random().toString(36).substr(2, 9) }>
                            <td className="v" width="40px"> { index+1 } </td>
                            <th scope="row" className="v">
                              <p className="cursor nm" onClick={()=>{fichaTramite(tramite.uuid_tramite)}}>{tramite.folio}</p>
                            </th>
                            <td className="v">
                              <small>{tramite.fecha_tramite}</small>
                            </td>
                            <td className={'estatus_'+(tramite.idestatus)+' v text-center'}>
                              {tramite.estatus}
                            </td>
                            <td className="v" width="25%">
                              <small><b>{tramite.nombres}</b><br/> {tramite.paterno} {tramite.materno}</small>
                            </td>
                            <td className="v" width="25%">
                              <small><b>{tramite.nombre_asesor}</b><br/> {tramite.paterno_asesor} {tramite.materno_asesor}</small>
                            </td>
                            <td className="v no_onmobile text-center" style={{"width":"40px"}}>
                                  <button type="button" onClick={()=>{mensajesTramite(tramite)}} className="btn btn-primary btn-link btn-xs position-relative">
                                    <i className={'fa '+( tramite.numero_mensajes > 0 ? 'fa-sticky-note' : 'fa-sticky-note-o') } />

                                      {
                                        tramite.numero_mensajes > 0 && (
                                            <span className="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-danger">
                                              {tramite.numero_mensajes}
                                              <span className="visually-hidden">Mensajes</span>
                                            </span>
                                        )
                                      }

                                  </button>
                            </td>
                          </tr>

                            )
                        }

                  </tbody>
                </table>



                {
                  // JSON.stringify(reporte.tramites[0])
                }


		        </Modal.Body>


		      </Modal>



      {
        showModalInforme && (
            <ModalInformeTramite onHideModalInforme={onHideModalInforme} showModalInforme={showModalInforme} uuid_tramite={uuid_tramite_modal} />
         )
      }


  {
    show_ModalNotasTramite && (
      <ModalNotasTramite show={show_ModalNotasTramite} handleClose={handleClose_ModalNotasTramite} tramite={data_tramite} />
      )

  }


		</React.Fragment>

	)

}


export default ListaTramiteGerente